import { getEntryProps } from '../utils/getEntryProps.js';
import { mapFooterProps } from './footer.js';
import { mapMicrocopyProps } from './microcopy.js';
import { mapNavbarProps } from './navbar.js';
import { mapEntryLink } from './navlink.js';
const CDX_SETTINGS_SITE_CONTENT_MODEL_ID = 'cdxSettingsSite';
const getSiteConfigProps = siteConfig => {
  const _getEntryProps = getEntryProps(siteConfig, {}),
    footer = _getEntryProps.footer,
    navbar = _getEntryProps.navbar,
    bannerText = _getEntryProps.bannerText,
    bannerLink = _getEntryProps.bannerLink,
    microcopies = _getEntryProps.microcopies;
  const navbarProps = mapNavbarProps(navbar);
  return {
    footer: mapFooterProps(footer),
    navbar: navbarProps,
    banner: {
      message: bannerText || '',
      url: bannerLink ? mapEntryLink(bannerLink).url : ''
    },
    microcopies: mapMicrocopyProps(microcopies)
  };
};
const getSiteConfigMicrocopies = siteConfig => {
  const _getEntryProps2 = getEntryProps(siteConfig),
    microcopies = _getEntryProps2.microcopies;
  return mapMicrocopyProps(microcopies);
};
export { CDX_SETTINGS_SITE_CONTENT_MODEL_ID, getSiteConfigMicrocopies, getSiteConfigProps };
//# sourceMappingURL=siteSettings.js.map
